<div>
  <h1>Selecione a empresa para importação em lote:</h1>
  <div class="search-box">
    <select [formControl]="searchType">
      <option value="1">BUSCA POR CNPJ</option>
      <option value="2">BUSCA POR RAZÃO SOCIAL</option>
    </select>
    <input
      #inputValue
      *ngIf="searchType.value == 1"
      [(ngModel)]="filterText"
      placeholder="01.234.567/0001-00"
      [textMask]="{
        mask: fiscalNumberMask,
        guide: false,
        keepCharPositions: true
      }"
      (keypress)="onPressEnterSearchCompanies($event)" />
    <input #inputValue *ngIf="searchType.value == 2" [(ngModel)]="filterText" placeholder="Razão Social" (keypress)="onPressEnterSearchCompanies($event)" />
    <div class="search-icon-container" (click)="searchCompanies(filterText)">
      <mat-icon aria-hidden="false">search</mat-icon>
    </div>
  </div>

  <div class="company-card" *ngIf="hasCompany()">
    <div class="company-logo">
      <img src="./assets/icons/no-logo-company-icon.svg" />
    </div>
    <div class="company-data">
      <div class="company-name">{{ company.getCorporateName() }}</div>

      <span class="company-cnpj"> CNPJ: {{ company.getFiscalNumber() | companyFederalNumber }} </span>
      <span class="company-lives">{{ company.getCompanyInfo().getEmployeeCount() }} vidas</span>
    </div>
  </div>
  <p class="txt" *ngIf="searchActionFired && searchNotFound">Nenhum resultado encontrado.</p>
  <hr *ngIf="searchActionFired" />

  <div class="on" *ngIf="hasCompany()">
    <p class="txt">
      Desbloquear vários beneficiários de uma vez. 
      <mat-icon aria-hidden="false" color="primary" matTooltip="Não há um template de modelo para essa ação. Basta enviar um arquivo CSV contendo uma única coluna com o número de CPF dos beneficiários e/ou dependentes para ação (bloqueio ou desbloqueio).">info</mat-icon>
    </p>
    <span *ngIf="importBeneficiaryResult">
      <p class="txt">Resultado da importação:</p>
      <div style="display: block; overflow-y: auto; max-height: 500px;">
        @for (item of importBeneficiaryResult.getMessages(); track $index) {
          <p class="txt">{{ item }}</p>
          }
      </div>
    </span>
    <div class="file-input">
      <form (ngSubmit)="uploadFile()">
        <label for="file" *ngIf="!fileName">Clique aqui para selecionar o arquivo .CSV</label>
        <label for="file" *ngIf="fileName">{{ fileName }}</label>
        <input type="file" accept=".csv" id="file" files (change)="getFile($event)" />
        <button class="btn"><mat-icon aria-hidden="false">add_box</mat-icon> DESBLOQUEAR BENEFICIÁRIOS EM LOTE</button>
      </form>
    </div>
  </div>
 
  <diV *ngIf="!hasCompany()" class="company-card-container">
    <div class="search-control">
      <p *ngIf="companyPageableResult.getItems().length > 1">{{ companyPageableResult.getItems().length }} RESULTADOS ENCONTRADOS</p>
      <p *ngIf="companyPageableResult.getItems().length === 1">1 RESULTADO ENCONTRADO</p>
      <div class="scroll-text" *ngIf="showScrollBottomBtn()" (click)="scrollToLastCompany()">
        <mat-icon aria-hidden="false">arrow_drop_down</mat-icon>
        <span class="btn-title">ir para o fim da lista</span>
      </div>
    </div>

    <div *ngFor="let company of companyPageableResult.getItems()">
      <div class="company-card">
        <div class="company-logo">
          <img src="./assets/icons/no-logo-company-icon.svg" />
        </div>
        <div class="company-data">
          <p class="company-name">{{ company.getCorporateName() }}</p>
          <p class="company-cnpj">CNPJ: {{ company.getFiscalNumber() | companyFederalNumber }}</p>
          <p class="company-description">{{ company.getTradingName() }}</p>
        </div>
        <div class="company-status">
          <div class="status">
            <mat-icon aria-hidden="false">check_circle_outline</mat-icon>
            ATIVA
          </div>
          <div class="edit-btn" (click)="searchCompany(company)"><mat-icon aria-hidden="false">lock_open</mat-icon> DESBLOQUEAR</div>
        </div>
      </div>
    </div>

    <a class="more-companies-btn" *ngIf="showMoreCompaniesBtn()" (click)="searchMoreCompanies()">carregar mais registros</a>
    <div id="bottom"></div>
  </diV>
</div>
